import { UiLocaleProvider } from "@nabble/ui";
import { createElement, type ComponentType } from "react";

/** The module's pages are in Spanish, like the reports they produce (the rest of the suite keeps its locale). */
export function spanish(Component: ComponentType): ComponentType {
  return function SpanishRoute(): React.JSX.Element {
    return <UiLocaleProvider locale="es"><div lang="es" className="reports-locale">{createElement(Component)}</div></UiLocaleProvider>;
  };
}
